module.exports = __webpack_public_path__ + "static/sport/login-success-new.9f5f896.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport5/login-success-new.png
// module id = G/n9
// module chunks = 0